import React, { FC } from 'react';
import { twMerge } from '@shared/utils/twMerge';

export const CircleDivider: FC<{ className?: string }> = ({ className }) => {
  return (
    <div
      className={twMerge('bg-pastelBlue mx-[6px] h-[6px] w-[6px] rounded-full', className)}
    ></div>
  );
};
